import script from "./RecommendedVouchersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendedVouchersPage.vue?vue&type=script&setup=true&lang=ts"

import "./RecommendedVouchersPage.vue?vue&type=style&index=0&id=11193eb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11193eb9"]])

export default __exports__